export default from './SavingsQuestion';



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/SavingsQuestion/index.js